import React from 'react';
import Link from '@material-ui/core/Link';
import Container from '@material-ui/core/Container';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';

class LoggedOut extends React.Component  {

    render() {

        return (
            <Container component="main" maxWidth="xs">
                <div className={this.props.classes.paper}>
                <Avatar className={this.props.classes.avatar}>
                    <ExitToAppOutlinedIcon/>
                </Avatar>
                <Typography component="h1" variant="h5">
                    Вы вышли. До скорого
                </Typography>
                <br/>
                <Link href="./" variant="body2">
                    Вход в портал
                </Link>
                </div>
            </Container>

        )

    }

}

export default LoggedOut;